import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const API = process.env.REACT_APP_API_URL;
const SLUG = 'plumbing-material';
// Fixed slots: img[0]=beside categories (pipe stock), img[1]=beside process (valve), img[2]=install strip
// Additional: img[3+]

const CATEGORIES = [
  { icon: '🔩', title: 'Pipes & Fittings', body: 'CPVC, uPVC, HDPE, GI and MS pipes with all matching fittings and joints.' },
  { icon: '🛢️', title: 'Tanks', body: 'HDPE overhead tanks and RCC/plastic underground sumps of all capacities.' },
  { icon: '🔧', title: 'Valves', body: 'Gate valves, ball valves, check valves, foot valves and pressure-reducing valves.' },
  { icon: '🚿', title: 'Sanitary', body: 'Bathroom fittings, flush tanks, taps and showers from premium brands.' },
];

const PlumbingMaterial = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/services/${SLUG}`)
      .then((r) => r.json())
      .then((d) => { if (d.success) setData(d.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="sp-loading"><div className="sp-spinner" /><p>Loading...</p></div>;
  if (!data) return null;

  const imgs = data.images || [];
  const heroStyle = data.bannerUrl ? { backgroundImage: `url(${data.bannerUrl})` } : {};
  const heroClass = `service-hero${data.bannerUrl ? '' : ' service-hero-gradient'}`;

  return (
    <div className="service-page">
      <div className={heroClass} style={heroStyle}>
        <div className="service-hero-content">
          {!data.bannerUrl && <div className="service-hero-icon">{data.icon}</div>}
          <h1>{data.title}</h1>
          <p>{data.subtitle}</p>
        </div>
      </div>

      <div className="pm-body">
        <div className="breadcrumb">
          <Link to="/">Home</Link> &rsaquo; <Link to="/">Services</Link> &rsaquo; <span>{data.title}</span>
        </div>

        <div className="pm-intro">
          <p>{data.intro}</p>
          <p>{data.intro2}</p>
        </div>

        {/* Categories grid + img[0] pipe stock on right — grid only if image uploaded */}
        {imgs[0] ? (
          <div className="pm-cat-wrap">
            <div className="pm-cat-boxes">
              <h2>What We Supply</h2>
              <div className="pm-cat-grid">
                {CATEGORIES.map((c) => (
                  <div className="pm-cat-box" key={c.title}>
                    <div className="pm-cat-header"><span>{c.icon}</span>{c.title}</div>
                    <div className="pm-cat-body"><p>{c.body}</p></div>
                  </div>
                ))}
              </div>
            </div>
            <div className="pm-pipe-img">
              <img src={imgs[0].url} alt={imgs[0].caption || data.title} />
            </div>
          </div>
        ) : (
          <div className="pm-cat-solo">
            <h2>What We Supply</h2>
            <div className="pm-cat-grid">
              {CATEGORIES.map((c) => (
                <div className="pm-cat-box" key={c.title}>
                  <div className="pm-cat-header"><span>{c.icon}</span>{c.title}</div>
                  <div className="pm-cat-body"><p>{c.body}</p></div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* img[1] valve close-up left + process list right — grid only if image uploaded */}
        {data.processSteps && data.processSteps.length > 0 && (
          imgs[1] ? (
            <div className="pm-proc-wrap">
              <div className="pm-valve-img">
                <img src={imgs[1].url} alt={imgs[1].caption || data.title} />
              </div>
              <div className="pm-process">
                <h2>{data.processTitle}</h2>
                <div className="pm-proc-list">
                  {data.processSteps.map((s) => (
                    <div className="pm-proc-item" key={s.step}>
                      <div className="pm-proc-badge">{s.step}</div>
                      <div>
                        <strong>{s.title}</strong>
                        <span>{s.desc}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div className="pm-process-solo">
              <h2>{data.processTitle}</h2>
              <div className="pm-proc-list">
                {data.processSteps.map((s) => (
                  <div className="pm-proc-item" key={s.step}>
                    <div className="pm-proc-badge">{s.step}</div>
                    <div>
                      <strong>{s.title}</strong>
                      <span>{s.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )
        )}

        {/* img[2]: installation strip — only if uploaded */}
        {imgs[2] && (
          <div className="pm-install-strip">
            <img src={imgs[2].url} alt={imgs[2].caption || data.title} />
          </div>
        )}

        {data.features && data.features.length > 0 && (
          <div className="pm-feats">
            <h2>{data.featuresTitle}</h2>
            {data.features.map((f) => (
              <div className="pm-feat" key={f.title}>
                <span>{f.icon}</span>
                <h4>{f.title}</h4>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        )}

        {data.specs && data.specs.length > 0 && (
          <div className="pm-specs">
            <h2>{data.specsTitle}</h2>
            <table><tbody>
              {data.specs.map((row, i) => <tr key={i}><td>{row[0]}</td><td>{row[1]}</td></tr>)}
            </tbody></table>
          </div>
        )}

        {imgs.length > 3 && (
          <div className="sp-additional-images">
            <h3>Additional Service Images</h3>
            <div className="sp-additional-grid">
              {imgs.slice(3).map((img) => (
                <div className="sp-additional-card" key={img.filename}>
                  <img src={img.url} alt={img.caption || data.title} />
                  {img.caption && <p>{img.caption}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="sp-cta">
          <h2>{data.ctaTitle}</h2>
          <p>{data.ctaText}</p>
          <a href="/#contact" className="sp-cta-btn">Get a Free Quote</a>
        </div>
      </div>
    </div>
  );
};

export default PlumbingMaterial;
